import classnames from 'classnames';
import { stringify } from 'qs';
import { List } from 'yoso';
import { useChallengeEventHistories } from '~/components/Challenge/Event/ChallengeEvent.hooks';
import { ChallengeEventItem } from '~/components/Challenge/Event/Item/ChallengeEventItem';
import { BaseError } from '~/components/Error/BaseError';
import { InfiniteList } from '~/components/List/Infinite/InfiniteList';
import { Link } from '~/components/Route/Link';
import styles from './ChallengeEventList.module.scss';

export type ChallengeEventListProps = {
  className?: string;
};

export const ChallengeEventList = ({ className }: ChallengeEventListProps) => {
  const { data, isFetching, isFetched, hasNextPage, fetchNextPage } = useChallengeEventHistories({
    keepPreviousData: true,
    initialData: undefined,
  });
  const pages = data?.pages || [];
  const isPageEmpty = pages[0]?.histories.length === 0;
  if (isFetched && isPageEmpty) {
    throw new BaseError('EMPTY');
  }
  return (
    <InfiniteList
      className={classnames(
        styles.root,
        { [styles.loading]: isFetching, [styles.initial]: !isFetched },
        className
      )}
      next={hasNextPage}
      onNextInView={() => fetchNextPage()}>
      {pages.map(({ histories }, i) => (
        <li className={styles.pageListItem} key={i}>
          <List className={styles.pageList}>
            {histories.map((item) => (
              <li key={item.week}>
                <Link
                  to={{
                    pathname: '/challenge/leaderboard',
                    search: stringify(
                      { eventId: item.week, group: 'RIVAL_GROUP' },
                      { addQueryPrefix: true }
                    ),
                  }}>
                  <ChallengeEventItem className={styles.eventItem} {...item} />
                </Link>
              </li>
            ))}
          </List>
        </li>
      ))}
    </InfiniteList>
  );
};
